import type { IOTFCutOffTable } from "../types/iotf.types";
import type { BiologicalSex } from "../types/patient.types";

export type IOTFLookupResult =
  | "meets_threshold"
  | "below_threshold"
  | "pending_data"
  | "sex_not_resolvable"
  | "no_entry_found";

export function resolveIOTFCutOff(
  ageMonths: number,
  biologicalSex: BiologicalSex,
  bmi: number,
  table: IOTFCutOffTable
): IOTFLookupResult {
  if (table.status === "pending_data") {
    return "pending_data";
  }

  if (biologicalSex === "other") {
    return "sex_not_resolvable";
  }

  const sex = biologicalSex as "male" | "female";

  const sexEntries = table.cutOffs
    .filter((c) => c.sex === sex)
    .sort((a, b) => b.ageMonths - a.ageMonths);

  if (sexEntries.length === 0) {
    return "no_entry_found";
  }

  const entry = sexEntries.find((c) => c.ageMonths <= ageMonths);

  if (entry === undefined) {
    return "no_entry_found";
  }

  return bmi >= entry.bmiCutOff ? "meets_threshold" : "below_threshold";
}
